import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Outlet, useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { visuallyHidden } from '@mui/utils';
import * as actions from './actionCreators';
import { SessionExpiredDialog } from '../components';
import GlobalErrorHandler from '../components/GlobalErrorHandler';
import { getLabelFromJspVariables } from '../common/JspUtil';

const skipLinkSx = {
    ...visuallyHidden,
    '&:focus': {
        clip: 'auto',
        clipPath: 'none',
        height: 'auto',
        width: 'auto',
        position: 'fixed',
        top: 8,
        left: 8,
        padding: '8px 12px',
        backgroundColor: '#000',
        color: '#fff',
        zIndex: 2000,
        textDecoration: 'underline',
    },
};

const LayoutContainer = () => {
    const dispatch = useDispatch();
    const location = useLocation();

    useEffect(() => {
        dispatch(actions.getEnvironment());
    }, []);

    useEffect(() => {
        const id = setTimeout(() => {
            const active = document.activeElement;
            const idle = !active || active === document.body;
            if (idle) {
                document.getElementById('main-content')?.focus({ preventScroll: false });
            }
        }, 0);
        return () => clearTimeout(id);
    }, [location.pathname]);

    return (
        <>
            <Link href="#main-content" sx={skipLinkSx} data-automation-id="layout_skip_to_main_link">{getLabelFromJspVariables('label_skip_to_main')}</Link>
            <Box component="main" id="main-content" tabIndex={-1} sx={{ outline: 'none' }}>
                <Outlet />
            </Box>
            <SessionExpiredDialog />
            <GlobalErrorHandler />
        </>
    );
};

export default LayoutContainer;
